import React from 'react';
import './Frames.scss';
import { useSelector, useDispatch } from 'react-redux';
import store, { RootState } from '../../../../Redux/Store/store';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { ActivateFrameAction } from '../../../../Redux/Actions/Animator/frames.list.action';
import { ActivateSideContextMenuAction } from '../../../../Redux/Actions/Atlas/contextSideMenu.action';
import { ObserverAnim, GLOBAL_EVENT_ANIM } from '../../Observer';
import { Observer } from '../../../AtlasPacker/Observer';
import { ReactSortable } from 'react-sortablejs';
import { equals } from 'ramda';
import { SwipeFrameAction } from '../../../../Redux/Actions/Animator/frames.list.action';

let _scrollBarRef: any;
let last_frame_div: HTMLDivElement;

export const Frames = () => {
    // last_frame = '';
    const frames_list_state = useSelector((state: RootState) => state.AnimationList);
    const frames_list = frames_list_state.animations.find(
        (animation: any) => animation.id === frames_list_state.actual_animation
    );

    const dispatch = useDispatch();

    if (last_frame_div !== undefined) {
        last_frame_div.classList.remove('frame-play');
    }

    // El frame Tracker
    Observer.removeListener(GLOBAL_EVENT_ANIM.RENDER.UPDATE_FRAMES);
    ObserverAnim.on(GLOBAL_EVENT_ANIM.RENDER.UPDATE_FRAMES, (frames: string) => {
        const actual_animation_list = store.getState().AnimationList;

        if (frames_list !== undefined && actual_animation_list.actual_animation !== '0') {
            const frame_div = document.getElementById(`${frames}`) as HTMLDivElement;

            if (last_frame_div !== undefined) {
                last_frame_div.classList.remove('frame-play');
            }

            if (frame_div !== undefined) {
                frame_div.classList.add('frame-play');
                last_frame_div = frame_div;
                const perfectScrollFrame = document.querySelector(
                    '.perfect-scroll-frames-container'
                ) as HTMLDivElement;
                perfectScrollFrame.scrollLeft = frame_div.offsetLeft - 150;
                _scrollBarRef.updateScroll();
            }
        }
    });

    return (
        <PerfectScrollbar
            className="perfect-scroll-frames-container"
            ref={(e) => (_scrollBarRef = e)}
        >
            <div>
                <h4 className="ml-2 mt-1 mb-2 text-color-primary">Frames</h4>
                <div className={`frames-container mr-2`}>
                    <ReactSortable
                        list={frames_list !== undefined ? frames_list.frames : []}
                        setList={(newState) => {
                            if (
                                !equals(
                                    newState,
                                    frames_list !== undefined ? frames_list.frames : []
                                )
                            ) {
                                dispatch(
                                    SwipeFrameAction({
                                        id: frames_list_state.actual_animation,
                                        frames: newState,
                                    })
                                );
                            }
                        }}
                        swap
                    >
                        {frames_list !== undefined &&
                            frames_list.frames.map((frame: any, key: number) => (
                                <div
                                    id={`${frame.name}_${key + 1}`}
                                    key={key}
                                    className={`images-frames--container ${
                                        frame.active ? 'frame-active' : ''
                                    }`}
                                    onClick={() => {
                                        dispatch(ActivateFrameAction({ local_id: frame.local_id }));
                                    }}
                                    onContextMenu={(event) => {
                                        dispatch(
                                            ActivateSideContextMenuAction({
                                                x: event.clientX,
                                                y: event.clientY,
                                                id: frame.local_id,
                                                options: {
                                                    value: 'frames',
                                                },
                                                active: true,
                                            })
                                        );
                                    }}
                                >
                                    <div>
                                        <img src={frame.src} alt={frame.name} title={frame.name} />
                                    </div>
                                </div>
                            ))}
                    </ReactSortable>
                </div>
            </div>
        </PerfectScrollbar>
    );
};
